<template>
  <index />
</template>

<script lang="ts">
import Index from '../../main_menu/_components/login/index.vue';

export default {
  name: 'navbar-cloud-dialog',
  components: { Index },
};
</script>
